import { useContext } from "react";
import { StepperContext } from "contexts";

export const useStepper = () => {
  return useContext(StepperContext);
};
